enum ROUTES {
    ROOT = '/',
    SOLICITUDES = 'solicitudes',
    DETALLE_SOLICITUD = 'solicitudes/detalle',
    SUPERVISOR_DISTRIBUCION = 'supervisor/reasignar',
    SUPERVISOR_SOLICITUD = 'supervisor/solicitudes',
    SUPERVISOR_SOLICITUD_DETALLE = 'supervisor/solicitudes/detalle',
    SUPERVISOR_SOLICITUD_SUBIR = 'supervisor/solicitudes/subir',
    EJEC_COBRANZA_AUTORIZACION = 'cobranza/autorizacion',
    EJEC_COBRANZA_AUTORIZACION_DETALLE = 'cobranza/autorizacion/detalle',
    CONSULTA_ORDENES_SUSCRIPCION = 'suscripcion/consulta'
  } 
  
  export default ROUTES;
  